var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLongArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.400024 6C0.400024 5.33726 0.937283 4.8 1.60002 4.8H15.502L12.7515 2.04853C12.3189 1.61595 12.2856 0.93527 12.6517 0.464521L12.7515 0.351472C13.1841 -0.0811089 13.8648 -0.114384 14.3355 0.251646L14.4486 0.351472L19.2486 5.15147L19.2982 5.20422L19.3644 5.28563L19.4504 5.41913L19.5146 5.5544L19.557 5.68081L19.5918 5.85903L19.6 6L19.5967 6.09029L19.5757 6.24087L19.5403 6.37457L19.4876 6.50787L19.4248 6.62485L19.3447 6.7401C19.3148 6.77816 19.2827 6.81437 19.2486 6.84853L14.4486 11.6485C13.9799 12.1172 13.2201 12.1172 12.7515 11.6485C12.3189 11.2159 12.2856 10.5353 12.6517 10.0645L12.7515 9.95147L15.502 7.2H1.60002C0.937283 7.2 0.400024 6.66274 0.400024 6Z",
    fill: "#406FDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrow);
export default __webpack_public_path__ + "static/media/long-arrow.94d43d05b2c08a2d627451059ae252dd.svg";
export { ForwardRef as ReactComponent };